import Header from "../../header/header";
import { useTranslation } from "react-i18next";

const HeaderLayout = ({
  title,
  search,
  create,
  apply,
  cancel,
  isBold,
  filters,
  period,
  editable,
  isEditing,
  onToggleEdit,
  onSave,
  onCancelEdit,
  saveDisabled,
  menuItems
}) => {
  const { t } = useTranslation();

  return (
    <Header
      title={title}
      search={
        search && {
          value: search.value,
          onChange: search.onHandleChange,
          placeholder: t("assets.btn.search"),
          testID: search.testID,
        }
      }
      create={create}
      cancel={cancel}
      apply={apply}
      menuItems={menuItems}
      isBold={isBold}
      filters={filters}
      period={period}
      editable={editable}
      isEditing={isEditing}
      onToggleEdit={onToggleEdit}
      onSave={onSave}
      onCancelEdit={onCancelEdit}
      saveDisabled={saveDisabled}
    />
  );
};

export default HeaderLayout;
